import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { UiGrayListCard } from "../../common/UiGrayListCard";
import { UiTooltip } from "../../common/UiTolltip";
import { UiTooltipItem } from "../../common/UiTooltipItem";
import { DeleteIconFloating } from "../../../../../public/styles/img/svg/DeleteIconFloating";
import { VerticalDotsIcon } from "../../../../../public/styles/img/svg/VerticalDotsIcon";
import { notificationConstants } from "../../../../_redux/_constants";

export const UiNotificationItem = (props) => {
  const { t, i18n } = useTranslation();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isTooltipOpen) {
        setIsTooltipOpen(false);
      }
    };

    if (isTooltipOpen) {
      window.addEventListener("scroll", handleScroll, true);
      document.addEventListener("scroll", handleScroll, true);

      return () => {
        window.removeEventListener("scroll", handleScroll, true);
        document.removeEventListener("scroll", handleScroll, true);
      };
    }
  }, [isTooltipOpen]);

  return (
    <>
      <UiGrayListCard
        className={
          props.status === notificationConstants.NOTIFICATION_READ
            ? "df-notification-item df-read"
            : "df-notification-item"
        }
      >
        <div className="df-notification-item__icon" onClick={props?.onClick}>
          {props?.icon && <img src={props?.icon} />}
        </div>
        <div className="df-notification-item__desc" onClick={props?.onClick}>
          <p className="df-notification-item__desc-para">{props?.message}</p>
          <p className="df-notification-item__desc-date">{props?.date}</p>
        </div>
        <div className="df-notification-item__action">
          <UiTooltip
            triggerIcon={<VerticalDotsIcon />}
            className="df-smail-msg-tooltip"
            isOpen={isTooltipOpen}
            setIsOpen={setIsTooltipOpen}
          >
            <UiTooltipItem
              className="df-white-boxed-tooltip"
              onClick={props?.deletehandler}
            >
              <DeleteIconFloating /> <span>{t("Delete")}</span>
            </UiTooltipItem>
          </UiTooltip>
        </div>
      </UiGrayListCard>
    </>
  );
};
